import { PaginatedCompanyReportList } from '@shared/api/types';
import { DataTable } from '@shared/components/data-table/data-table';
import { useServerDataTable } from '@shared/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@shared/components/data-table/types';
import { cn } from '@shared/lib/utils';
import { generatePath, useNavigate } from 'react-router-dom';
import { ccfRoutes } from '../../../ccf-routes';
import { reportTableColumns } from '../../components/ccf-list-table-columns';
import CCFReportCard from './ccf-report-card';

interface CCFReportTableProps
  extends Partial<DataTableProps<PaginatedCompanyReportList>> {
  type?: 'table' | 'card';
}

export default function CCFReportTable({
  enableRowClick = true,
  type = 'table',
  data,
}: CCFReportTableProps) {
  const navigate = useNavigate();

  const pageCount = 1;

  const { table } = useServerDataTable({
    data: data?.results || [],
    columns: reportTableColumns,
    pageCount,
    defaultPerPage: 10,
    columnVisibilityState: {
      uuid: false,
    },
    rowId: 'uuid',
  });

  return (
    <DataTable
      table={table}
      showHeader={type === 'card' ? false : true}
      onRowClick={(row) => {
        if (!enableRowClick) return;
        const uuid = row?.original.uuid;
        navigate(generatePath(ccfRoutes.COMPANY_REPORT, { report_uuid: uuid }));
      }}
      rowClassName={() => cn('', { 'bg-gray-25 border-none': type === 'card' })}
      enablePagination
      customRowItem={
        type === 'card'
          ? (row) => (
              <CCFReportCard
                report={row.original}
                className="mb-3 cursor-pointer"
              />
            )
          : undefined
      }
    />
  );
}
